import { useEffect, useState } from 'react'

interface IAdConfig {
  homeTopAdShow: boolean | undefined
  isShowClose: boolean
}

type Subscriber = () => void

const subscribers = new Set<Subscriber>()

// 天幕广告相关的控制
let adConfig: IAdConfig = {
  homeTopAdShow: undefined,
  isShowClose: true,
}

export function setAdConfig({
  homeTopAdShow = false,
  isShowClose = false,
}: Partial<IAdConfig>) {
  const newAdConfig = { homeTopAdShow, isShowClose }
  if (
    (['homeTopAdShow', 'isShowClose'] as (keyof IAdConfig)[]).every(
      (prop) => adConfig[prop] === newAdConfig[prop]
    )
  ) {
    return
  }
  adConfig = newAdConfig
  for (const subscriber of subscribers) {
    subscriber()
  }
}

function useAdConfig() {
  const [config, setConfig] = useState<IAdConfig>(adConfig)

  useEffect(() => {
    const subscriber = () => {
      setConfig(adConfig)
    }
    subscribers.add(subscriber)
    return () => {
      subscribers.delete(subscriber)
    }
  }, [])

  return config
}

export default useAdConfig
